import React, { useEffect, useState } from 'react'
import WithHOC from './actions'
import { Table, Switch, Typography, Row, Col, Space, Button, Modal, Tag } from 'antd'
import { PlusOutlined, EditTwoTone, DeleteTwoTone, MailTwoTone } from '@ant-design/icons'
import LoadingOverlay from 'components/LoadingOverlay'
import AddUserModal from './AddUserModal'
import UpdateUserModal from './UpdateUserModal'
import { Container } from 'react-bootstrap'
import { getItem } from 'utils/tokenStore'
import { formatDateTime } from 'utils/dateFormat'
import { useTranslation } from 'react-i18next';

const Users = props => {
	const { t } = useTranslation();
	const { Title } = Typography
	const [ isAdminTable, setIsAdminTable ] = useState(false)
	const [ addVisible, setAddVisible ] = useState(false);
  const [ updateVisible, setUpdateVisible ] = useState(false);

	const timezoneOffset = new Date().getTimezoneOffset();

	const admin_columns = [
		{
			key: "ID",
			title: t("UserPage.table.id"),
			dataIndex: "ID",
			sorter: (a, b) => a.ID - b.ID,
		},
		{
			key: "LOGIN_NAME",
			title: t("UserPage.table.loginName"),
			dataIndex: "LOGIN_NAME",
		},
		{
			key: "FULL_NAME",
			title: t("UserPage.table.fullName"),
			dataIndex: "FULL_NAME",
		},
		{
			key: "EMAIL",
			title: t("UserPage.table.email"),
			dataIndex: "EMAIL",
		},
		{
			key: "PHONE",
			title: t("UserPage.table.phone"),
			dataIndex: "PHONE",
		},
		{
			key: "STATUS",
			title: t("UserPage.table.status"),
			render: (_, user) =>
				user.STATUS === 0
					? t("userStatus.register")
					: user.STATUS === 1
					? t("userStatus.addPassword")
					: user.STATUS === 2
					? t("userStatus.login")
					: user.STATUS === 3
					? t("userStatus.logout")
					: "",
		},
		{
			key: "CREATED",
			title: t("UserPage.table.created"),
			render: (_, user) => (
				<>
					{formatDateTime(user["CREATED"])}
				</>
			),
		},
		{
			key: "LAST_UPDATE",
			title: t("UserPage.table.lastModified"),
			render: (_, user) => <>{user["LAST_UPDATE"]}</>,
		},
		{
			title: t("UserPage.table.action"),
			render: (_, user) => (
				<Space>
					<EditTwoTone
						onClick={() => {
							props.onChangeHOC("selectedUser", user);
							showUpdateModal();
						}}
					/>
					<DeleteTwoTone
						onClick={() =>
							Modal.confirm({
								title: t("UserPage.actions.deleteUser.title"),
								content: t("UserPage.actions.deleteUser.content", {
									name: user.FULL_NAME,
								}),
								okText: t("Confirm"),
								cancelText: t("Cancel"),
								onOk: () => {
									props.deleteUser(user);
								},
							})
						}
					/>
					<MailTwoTone
						onClick={() =>
							Modal.confirm({
								title: t("UserPage.actions.resetPassword.title"),
								content: t("UserPage.actions.resetPassword.content"),
								okText: t("UserPage.actions.resetPassword.ok"),
								cancelText: t("Cancel"),
								onOk: () => {
									props.resetPassword(user);
								},
							})
						}
					/>
				</Space>
			),
		},
	];

	const user_columns = [
		{
			key: "ID",
			title: t("UserPage.table.id"),
			dataIndex: "ID",
			sorter: (a, b) => a.ID - b.ID,
		},
		{
			key: "LOGIN_NAME",
			title: t("UserPage.table.loginName"),
			dataIndex: "LOGIN_NAME",
		},
		{
			key: "FULL_NAME",
			title: t("UserPage.table.fullName"),
			dataIndex: "FULL_NAME",
		},
		{
			key: "EMAIL",
			title: t("UserPage.table.email"),
			dataIndex: "EMAIL",
		},
		{
			key: "PHONE",
			title: t("UserPage.table.phone"),
			dataIndex: "PHONE",
		},
		{
			key: "STATUS",
			title: t("UserPage.table.status"),
			render: (_, user) =>
				user.STATUS === 0
					? t("userStatus.register")
					: user.STATUS === 1
					? t("userStatus.addPassword")
					: user.STATUS === 2
					? t("userStatus.login")
					: user.STATUS === 3
					? t("userStatus.logout")
					: "",
		},
		{
			key: "CREATED",
			title: t("UserPage.table.created"),
			render: (_, user) => (
				<>
					{formatDateTime(user["CREATED"])}
				</>
			),
		},
		{
			key: "ROOM_NAME",
			title: t("UserPage.table.assignRoom"),
			render: (_, user) => (
				<>
					{user["ROOM_NAME"] !== undefined && user["ROOM_NAME"]
						? user["ROOM_NAME"].split(",").map((data, index) => {
								return (
									<Tag color="geekblue" key={index}>
										{data}
									</Tag>
								);
							})
						: ""}
				</>
			),
		},
		{
			title: t("UserPage.table.action"),
			render: (_, user) => (
				<Space>
					<EditTwoTone
						onClick={() => {
							let selectedUser = user;
							if (typeof selectedUser.ROOM_NAME === "string") {
								selectedUser.DEVICE_LOC = selectedUser.ROOM_NAME.split(",");
							} else if (selectedUser.ROOM_NAME == null) {
								selectedUser.DEVICE_LOC = [];
							}

							props.onChangeHOC("selectedUser", selectedUser);
							showUpdateModal();
						}}
					/>
					<DeleteTwoTone
						onClick={() =>
							Modal.confirm({
								title: t("UserPage.actions.deleteUser.title"),
								content: t("UserPage.actions.deleteUser.content", {
									name: user.FULL_NAME,
								}),
								okText: t("Confirm"),
								cancelText: t("Cancel"),
								onOk: () => {
									props.deleteUser(user);
								},
							})
						}
					/>
					<MailTwoTone
						onClick={() =>
							Modal.confirm({
								title: t("UserPage.actions.resetPassword.title"),
								content: t("UserPage.actions.resetPassword.content"),
								okText: t("UserPage.actions.resetPassword.ok"),
								cancelText: t("Cancel"),
								onOk: () => {
									props.resetPassword(user);
								},
							})
						}
					/>
				</Space>
			),
		},
	];

	const showAddModal = () => {
    setAddVisible(true);
  };

	const closeAddModal = () => {
    setAddVisible(false);
  };

  const closeUpdateModal = () => {
    setUpdateVisible(false);
  };

  const showUpdateModal = () => {
    setUpdateVisible(true);
  };

  const handleUpdateCancel = () => {
    setUpdateVisible(false);
  };

  const handleUpdateOk = () => {
    setUpdateVisible(false);
  };

	useEffect(() => {
		if (getItem("LOGIN_TOKEN")){
			props.getUsers()
			props.suggestRoom('')
    }
	}, [])

	return (
		<Container>
      <Row style={{ alignItems: "center" }}>
        <Col span={12}>
          <Space>
            <Title>
              {t("listOf")} {isAdminTable ? t("Admins") : t("Users")}
            </Title>
            <Switch
              style={{ float: "right" }}
              className="mb-2"
              checkedChildren={t("Admins")}
              unCheckedChildren={t("Users")}
              checked={isAdminTable}
              onChange={(val) => setIsAdminTable(val)}
            />
          </Space>
        </Col>
        <Col span={12}>
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            style={{ background: "#1890ff", borderColor: "#1890ff", float: "right" }}
            onClick={showAddModal}
          >
            {t("Add")} {isAdminTable ? t("Admin") : t("User")}
          </Button>
        </Col>
      </Row>

      {isAdminTable ? (
        <Table
          id="adminTable"
          dataSource={props.admins}
          columns={admin_columns}
          rowKey="ID"
          pagination={{
            pageSizeOptions: ["10", "20", "50"],
            showSizeChanger: true,
            defaultPageSize: 10,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} ${t("of")} ${total} ${t("items")}`,
          }}
        />
      ) : (
        <Table
          id="userTable"
          dataSource={props.users}
          columns={user_columns}
          rowKey="ID"
          pagination={{
            pageSizeOptions: ["10", "20", "50"],
            showSizeChanger: true,
            defaultPageSize: 10,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} ${t("of")} ${total} ${t("items")}`,
          }}
        />
      )}

      {props.onLoading && <LoadingOverlay />}

      <AddUserModal
        visible={addVisible}
        action={props.registerUser}
        close={closeAddModal}
        rooms={props.rooms}
        suggestions={props.roomSuggestions}
      />
      {updateVisible && (
        <UpdateUserModal
          visible={updateVisible}
          action={props.updateUser}
          close={closeUpdateModal}
          selectedUser={props.selectedUser}
          rooms={props.rooms}
          suggestions={props.roomSuggestions}
        />
      )}
    </Container>
	)
}

export default WithHOC(Users)